document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element) || event.defaultPrevented) return;
  const choice = event.target.closest('.hx-home-swatches a');
  if (!(choice instanceof HTMLAnchorElement)) return;
  if (event instanceof MouseEvent && (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)) return;
  const card = choice.closest('.hx-product');
  const image = card?.querySelector('.hx-product-main img');
  const empty = card?.querySelector('.hx-home-photo-empty');
  if (!(image instanceof HTMLImageElement) || !(empty instanceof HTMLElement)) return;
  event.preventDefault();
  const source = choice.dataset.hoxoImage;
  image.hidden = !source;
  empty.hidden = Boolean(source);
  if (source) {
    image.removeAttribute('srcset');
    image.src = source;
    image.alt = choice.dataset.hoxoAlt || choice.title;
  }
  for (const link of card.querySelectorAll('.hx-product-main,.hx-product-action')) link.href = choice.href;
  for (const swatch of card.querySelectorAll('.hx-home-swatches a')) swatch.setAttribute('aria-current', String(swatch === choice));
  const price = card.querySelector('.hx-product-main strong');
  if (price && choice.dataset.hoxoPrice) price.textContent = choice.dataset.hoxoPrice;
});
